// extracted by mini-css-extract-plugin
export default {"collections":"Carousel3DExample_collections__0DQBi","slide":"Carousel3DExample_slide__OcpQN","animation":"Carousel3DExample_animation__zCiWR"};